export default __webpack_public_path__ + "static/media/help_2_buff.a07ebfb2.gif";